import { SAMPLE_PDF } from '@/_shared/constants/samplePdf';
import { PaymentFromBE, PaymentStatus, PendingPaymentFromBE } from '../types';

export const MOCK_RESPONSE_GET_PAYMENTS: {
  data: PaymentFromBE[];
  totalItems: number;
} = {
  data: [
    {
      transactionName: 'Payment slash - Recharge',
      amount: 100.0,
      paymentDate: '2025-05-08',
      paymentId: 'pi_3RMRSj2Zdh5HuNTw1gGik4IR',
      productName: '',
      organizationId: '1a87860c-84cb-4f90-8545-5967fc6912e3',
      status: PaymentStatus.PAID,
      organizationName: null,
      paymentMethod: 'BANK_TRANSFER',
      bankInfo: {
        accountHolderName: 'John Doe',
        bic: 'ITTPIT2MXXX',
        country: 'Italy',
        iban: 'IT60X0542811101000000123456',
      },
    },
  ],
  totalItems: 1,
};

export const MOCK_RESPONSE_GET_PENDING_PAYMENTS: {
  data: PendingPaymentFromBE[];
  totalItems: number;
} = {
  data: [
    {
      transactionName: 'Payment slash - Recharge',
      amount: 100.0,
      paymentId: 'pi_3RMRSj2Zdh5HuNTw1gGik4IR',
      productName: '',
      organizationId: '1a87860c-84cb-4f90-8545-5967fc6912e3',
      status: PaymentStatus.PENDING,
      paymentMethod: 'BANK_TRANSFER',
      bankInfo: {
        accountHolderName: 'John Doe',
        bic: 'ITTPIT2MXXX',
        country: 'Italy',
        iban: 'IT60X0542811101000000123456',
      },
    },
  ],
  totalItems: 1,
};

export const MOCK_RESPONSE_POST_PAYMENTS_CREATE = {
  url: 'https://buy.stripe.com/test_dR6bITg2Y0xLbQc6op?locale=it',
};

export const MOCK_RESPONSE_GET_DOWNLOAD_PAYMENT_RECEIPT: Blob = SAMPLE_PDF;
